import { updateParams } from "../../api";
import { showNotification } from "../actions/setting";
import { listActiveSettingT } from "../reducers/Settings";
import { TYPE_REDUCER } from "../utils/constants";

type field = {
    dataType: string
    editable: string
    value: any
    variableName: string

}
export type responseMessageT = {
    error: boolean
    field: string
    message: string

}
type responseUpdateParams = {
    fields: field[],
    messages: responseMessageT[],
    products: [],
    uuid: string,
    valid: string
}


export const middleware = (store: any) => (next: any) => (action: any) => {


    switch (action.type) {


        case TYPE_REDUCER.SET_VALUE_OPTIONS: {

            let { idParams, valueParam } = action['payload']
            let fields = [{
                "variableName": idParams,
                "value": valueParam
            }]
            let storeCopy = JSON.parse(JSON.stringify(store.getState()));

            let activeSettingUINew: listActiveSettingT[] = storeCopy['Configuration']['paramsConfiguration']['activeSettingUI'];
            let activeSection: string = storeCopy['Configuration']['sections']['activeSection'];

            let activeSectionOptions: listActiveSettingT = activeSettingUINew.filter((listActiveSetting: listActiveSettingT) => listActiveSetting['sectionId'] === activeSection)[0]

            if (idParams === "ShipVia") {
                let purchaseOption = activeSectionOptions['listOptions'].filter((item: any) => item['optionId'] === 'PurchaseOpt')[0]
                fields.push({
                    "variableName": purchaseOption['optionId'],
                    "value": purchaseOption['value']
                })
            }

            updateParams({ "fields": fields })
                .then((res: responseUpdateParams) => {
                    // if (res['messages'].length > 0) { 
                    //     store.dispatch(showNotification(res['messages']))
                    // } 
                    store.dispatch(showNotification(res['messages']))
                    // store.dispatch(updateSettings(res['fields']))
                }).catch(() => {

                })

            break;
        }


        default:
            break
    }

    let result = next(action);




    return result;
};